import { Component } from '@angular/core';
import { IcdCodeListComponent } from '../icd-code-list/icd-code-list';
import { IcdCodeType } from '../../../../core/api/mhsConfigurationApiClient';

@Component({
  selector: 'app-icd9-view',
  imports: [IcdCodeListComponent],
  templateUrl: './icd9-view.html',
  styleUrl: './icd9-view.scss',
})
export class Icd9ViewComponent {
  readonly codeType = IcdCodeType.Icd9;
}
